/**
 * Insere funcionalidades adicionais nos objetos Button
 *
 * @author Wellington
 * @since 2025-05-22
 * @version 1.0.0
 * @license Comercial
 */

const htmlTableSectionElementExtensions = {
  /**
   * Adiciona uma linha
   */
  addRow() {
    const row = document.createElement('tr');

    if (this.tagName === 'TBODY') {
      const id = this.querySelectorAll('tr').length + 1;
      row.dataset.id = id;
      row.classList.add(id % 2 ? 'dg-even' : 'dg-odd');
    }

    this.appendChild(row);
    return row;
  }
};

/**
 * Adiciona os métodos ao protótipo de HTMLTableSectionElement
 */
const extendHTMLTableSectionElement = () => {
  Object.entries(htmlTableSectionElementExtensions).forEach(([key, value]) => {
    if (!HTMLTableSectionElement.prototype[key]) {
      HTMLTableSectionElement.prototype[key] = value;
    } else {
      console.warn(`HTMLTableSectionElement.prototype.${key} já existe e não será sobrescrito.`);
    }
  });
};

export default extendHTMLTableSectionElement;
